import React from "react";
import { JsonLd } from "../components/common/JsonLd";
import { RelatedPages } from "../components/common/RelatedPages";
import { SEOHelmet } from "../components/common/SEOHelmet";
import { PATH_PSYCHIATRIE } from "../utils/constants";
import { Testimonial, TestimonialsComponent } from "../components/common/testimonial/TestimonialComponent";
import pageData from "../data/pages/psychiatrie.json";
import { mapPageSections } from "../utils/pageContent";
import { buildSeoPageGraph } from "../utils/structured-data";

type Section = {
  title: string;
  text?: string;
  content?: string[];
  img?: string;
  ratio?: string;
};

const data = {
  sections: mapPageSections(pageData.sections as Section[]),
  testimonials: pageData.testimonials as Testimonial[],
};

export default function PsychiatryPage() {
  return (
    <>
      <SEOHelmet page="psychiatrie" pathname={PATH_PSYCHIATRIE} />
      <JsonLd
        data={buildSeoPageGraph(PATH_PSYCHIATRIE, "psychiatrie", {
          medicalSpecialty: "Psychiatric",
        })}
      />

      <main className="space-y-14">
        {data.sections.map((section, index) => (
          <div key={index}>
            {index === 0 ? (
              <div className="grid lg:grid-cols-2 gap-12 items-start">
                <div>
                  <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-gray-900 dark:text-white mb-6">
                    {section.title}
                  </h1>
                  <p className="text-base text-gray-500 dark:text-gray-400 leading-relaxed">{section.text}</p>
                </div>
                {section.img && (
                  <div>
                    <img
                      src={section.img}
                      alt="Psychiatrische Ergotherapie Rottweil - Behandlung von Depression, Burnout, Angststörungen und psychischen Belastungen"
                      className={`w-64 md:w-96 lg:w-full rounded-2xl object-cover shadow-sm ${section.ratio || ""}`}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className={section.img ? "grid lg:grid-cols-2 gap-12 items-start" : ""}>
                <div>
                  <h2 className="text-xl sm:text-2xl font-semibold tracking-tight text-ergo-600 dark:text-ergo-400 mb-4">
                    {section.title}
                  </h2>
                  {section.content && (
                    <ul className="list-disc marker:text-ergo-400 dark:marker:text-ergo-500 list-inside space-y-2 text-base text-gray-500 dark:text-gray-400">
                      {section.content.map((item, itemIndex) => (
                        <li key={itemIndex} className="leading-relaxed">
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                  {section.text && (
                    <p className="text-base text-gray-500 dark:text-gray-400 leading-relaxed">{section.text}</p>
                  )}
                </div>
                {section.img && (
                  <div>
                    <img
                      src={section.img}
                      alt="Psychiatrische Therapie in der Praxis - Individuelle Übungen für psychisches Wohlbefinden"
                      className={`w-64 md:w-96 lg:w-full rounded-2xl object-cover shadow-sm ${section.ratio || ""}`}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        ))}

        <div className="mt-14">
          <TestimonialsComponent testimonials={data.testimonials} />
        </div>
        <RelatedPages pathname={PATH_PSYCHIATRIE} />
      </main>
    </>
  );
}
